const MENU = {
  HOME: {
    name: "HOME",
    path: "/",
    component: () => import("@/views/home/Home.vue"),
    meta: {
      title: "스포티비프라임｜SPOTVPRIME",
    }
  },  
  SCHEDULE: {
    name: "편성표",
    path: "/schedule",
    component: () => import("@/views/schedule/Schedule.vue"),
    meta: {
      title: "편성표｜스포티비프라임｜SPOTVPRIME"
    }
  },
  CHANNEL: {
    name: "채널번호",
    path: "/channel",
    component: () => import("@/views/channel/Channel.vue"),
    meta: {
      title: "채널번호｜스포티비프라임｜SPOTVPRIME"
    }
  },
  NOTICE: {
    name: "공지 · 이벤트",
    path: "/notice",
    component: () => import("@/views/board/Board.vue"),
    meta: {
      title: "공지/이벤트｜스포티비프라임｜SPOTVPRIME"
    }
  },
};

const SUBMENU = {
  ADVERTISE: {
    path: "/advertise", 
    component: () => import("@/views/support/Advertise.vue"),
    meta: {
      title: "광고문의｜스포티비프라임｜SPOTVPRIME"
    }
  },
  CONTACT: {
    path: "/contact", 
    component: () => import("@/views/support/Contact.vue"),
    meta: {
      title: "사업제휴문의｜스포티비프라임｜SPOTVPRIME"
    }
  },
  LOCATION: { 
    path: "/location", 
    component: () => import("@/views/support/Location.vue"),
    meta: {
      title: "오시는 길｜스포티비프라임｜SPOTVPRIME"
    }
  },
}

export { MENU, SUBMENU }